<template>
  <span
    class="inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap"
    :class="isOffline
      ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
      : 'border-blue-200 bg-blue-50 text-blue-700'"
  >
    {{ isOffline ? 'В клинике' : 'Онлайн' }}
  </span>
</template>

<script>
export default {
  name: 'AppointmentFormatBadge',
  props: {
    format: {
      type: String,
      default: 'online'
    }
  },
  computed: {
    isOffline() {
      return this.format === 'offline'
    }
  }
}
</script>
